
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners",
      function () {
        return require("private-next-pages/partners/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners"])
      });
    }
  